module.exports = __webpack_public_path__ + "static/media/test16_1.117ecae5.png";